export const OPERATOR_PHONE_CLEAR_STORE = "OPERATOR_PHONE_CLEAR_STORE";

export const OPERATOR_PHONE_NEW_SAVE_START = "OPERATOR_PHONE_NEW_SAVE_START";
export const OPERATOR_PHONE_NEW_SAVE_SUCCESS = "OPERATOR_PHONE_NEW_SAVE_SUCCESS";
export const OPERATOR_PHONE_NEW_SAVE_FAIL = "OPERATOR_PHONE_NEW_SAVE_FAIL";

export const OPERATOR_PHONE_SAVE_START = "OPERATOR_PHONE_SAVE_START";
export const OPERATOR_PHONE_SAVE_SUCCESS = "OPERATOR_PHONE_SAVE_SUCCESS";
export const OPERATOR_PHONE_SAVE_FAIL = "OPERATOR_PHONE_SAVE_FAIL";

export const OPERATOR_PHONE_DETAIL_START = "OPERATOR_PHONE_DETAIL_START";
export const OPERATOR_PHONE_DETAIL_SUCCESS = "OPERATOR_PHONE_DETAIL_SUCCESS";
export const OPERATOR_PHONE_DETAIL_FAIL = "OPERATOR_PHONE_DETAIL_FAIL";
